export default __webpack_public_path__ + "static/verso-3-2f044b07b0e253a5cb5ecf5f3d1a63d5.jpg";